<template>
  <div class="steps-progressbar">
    <div
      class="steps-progressbar__text"
      :style="{
        fontSize: `${props.fontSize}px`,
        lineHeight: `${props.fontSize}px`,
      }"
    >
      Step {{ props.currentStep }} of {{ props.numberOfSteps }}
    </div>
    <div class="steps-progressbar__scale">
      <div
        :class="{
          'steps-progressbar__progress-line': true,
          'steps-progressbar__progress-line--green': props.color === 'green',
          'steps-progressbar__progress-line--teal': props.color === 'teal',
        }"
        :style="{
          width: `${(100 / props.numberOfSteps) * props.currentStep}%`,
        }"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    currentStep: number;
    numberOfSteps: number;
    fontSize?: number;
    color?: "teal" | "green";
  }>(),
  {
    currentStep: 1,
    numberOfSteps: 1,
    fontSize: 14,
    color: "green",
  }
);
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

// Steps progressbar ==========================================================
.steps-progressbar {
  &__text {
    margin-bottom: 7px;
    color: rgba(0, 0, 0, 1);
    font:
      700 14px/14px "Quicksand",
      sans-serif;
  }

  &__scale {
    height: 8px;
    border-radius: 100px;
    position: relative;
    overflow: hidden;
    font-size: 0;
    line-height: 0;
    background: rgba(217, 217, 217, 1);
  }

  &__progress-line {
    width: 0;
    height: 100%;
    border-radius: 100px 0 0 100px;
    position: absolute;
    inset: 0 auto auto 0;
    transition: width 0.3s ease-in-out;

    &--green {
      background: rgba(80, 163, 56, 1);
    }

    &--teal {
      background: $brand-color;
    }
  }
}
</style>
